<script lang="ts" setup>
import { useGlobalProperties } from '@/src/composables/useGlobalProperties';
import SeLink from '@/src/components/Link.vue';
import { theme } from '@/theme';
import { computed } from 'vue';

const { getGlobalProperties } = useGlobalProperties();
const { $route } = getGlobalProperties();

const config = theme.general;

const isBannerVisible = computed(
  () =>
    !config.siteActive &&
    $route.path !== '/dashboard/chat' &&
    !$route.path.includes('/get-started') &&
    !$route.path.includes('/dashboard/inbox')
);
</script>

<script lang="ts">
export default {
  name: 'SeHeaderMigrationBanner',
};
</script>

<template>
  <div v-if="isBannerVisible" class="bg-gradient-primary flex items-center justify-center w-full px-16 md:px-32">
    <div class="px-16 py-12 !pl-0">
      <div class="flex items-center justify-between md:justify-center">
        <div class="text-center">
          <p class="text-white text-b-m md:text-h-l font-bold">
            🔔 {{ config.siteName }} is closed!
            <span class="hidden xs:inline-block xs:visible"> — </span>
            <br class="xs:hidden" />
            but we’re not going anywhere!
          </p>
          <p class="text-white text-b-s md:text-h-m">
            You can continue your readings with the same trusted advisors on our sister site
            <se-link href="https://www.seeer.com" target="_blank" class="!underline"><b>Seeer.com</b></se-link
            >. Join us there today!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
